import { httpRequest } from "@services/http";

export interface CreateAudiencePayload {
  name: string;
  rules: Record<string, any>;
  audience_preset_id?: number;
}

export class CommandUnlinkAdsToAudience {
  async run(launchId: number, adGroupId: number, adId: number) {
    const url = `${
      import.meta.env.VITE_API_PLATFORM_SERVICE_URL
    }api/v1/engagements/launches/${launchId}/ad-groups/${adGroupId}/ads/${adId}`;
    await httpRequest<any>(url, {
      method: "DELETE",
    });
    return;
  }
}
